import { isMessageEditorState, isMessageRespondedOrReviewed, isMessageReviewState, CLAIMED_FOR_FORWARD_REVIEW, VIEW_AS_MANAGER, VIEW_DIALOGUE_OPTIONS_AS_MANAGER, REVIEW_AS_MANAGER, REVIEW_ESCALATION_AS_MANAGER, DETAILED_REVIEW_AS_MANAGER } from "../../..";
const DEFAULT_EDITOR_HEIGHT = 265;
const DEFAULT_READ_ONLY_HEIGHT = 280;
const DEFAULT_SMALL_READ_ONLY_HEIGHT = 215;
const DEFAULT_NO_FOOTER = 150;
export const CC_HEIGHT = 35;
const NO_FOOTER_LIST = [VIEW_AS_MANAGER, CLAIMED_FOR_FORWARD_REVIEW, VIEW_DIALOGUE_OPTIONS_AS_MANAGER, REVIEW_AS_MANAGER, REVIEW_ESCALATION_AS_MANAGER];
export const calculateFooterAndHeaderHeight = conversationState => {
  if (conversationState.state === DETAILED_REVIEW_AS_MANAGER) {
    return DEFAULT_SMALL_READ_ONLY_HEIGHT;
  }
  if (NO_FOOTER_LIST.includes(conversationState.state)) {
    return DEFAULT_NO_FOOTER;
  }
  if (isMessageReviewState(conversationState.state)) {
    return DEFAULT_SMALL_READ_ONLY_HEIGHT;
  }
  if (isMessageEditorState(conversationState.state)) {
    return DEFAULT_EDITOR_HEIGHT + CC_HEIGHT;
  }
  if (isMessageRespondedOrReviewed(conversationState.state)) {
    return DEFAULT_SMALL_READ_ONLY_HEIGHT;
  }
  return DEFAULT_READ_ONLY_HEIGHT;
};